var Cell = /** @class */ (function () {
    function Cell(id, name, el) {
        this.object_id = id;
        this.column_name = name;
        this.original_value = el.innerHTML;
        this.el = el;
    }
    Cell.prototype.getObjectID = function () {
        return this.object_id;
    };
    Cell.prototype.getName = function () {
        return this.column_name;
    };
    Cell.prototype.getElement = function () {
        return this.el;
    };
    Cell.prototype.getRow = function () {
        return this.el.parentElement;
    };
    Cell.prototype.getSettings = function () {
        return AdminColumns.Table.Columns.get(this.getName());
    };
    Cell.prototype.hasChanged = function (content) {
        return this.original_value !== content;
    };
    Cell.prototype.setValue = function (value) {
        this.original_value = value;
        this.el.innerHTML = value;
        return this;
    };
    return Cell;
}());
export default Cell;
